module.exports = __webpack_public_path__ + "img/Sao-Tome-&-Principe.1d09cf3a.png";